import { Theme, useMediaQuery } from '@mui/material';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  ITravelCostInvoiceKindPickerProps,
  TravelCostInvoiceKindPicker,
} from '@work4all/components/lib/components/entity-picker/travel-cost-invoice-kind-picker/TravelCostInvoiceKindPicker';

import { reactRefSetter } from '@work4all/utils';

import { LabeledInput } from '../../containers/mask-overlays/locked-inputs';

interface TravelCostInvoiceKindPickerFieldProps
  extends Omit<ITravelCostInvoiceKindPickerProps<false>, 'multiple'> {
  error?: string;
  name?: string;
  label?: string;
  disabled?: boolean;
  required?: boolean;
}

export const TravelCostInvoiceKindPickerField = React.forwardRef<
  HTMLDivElement,
  TravelCostInvoiceKindPickerFieldProps
>(function Field(props, ref) {
  const { error, label, disabled, required, ...pickerProps } = props;

  const { t } = useTranslation();

  const wrapperRef = useRef<HTMLDivElement>(null);
  const popoverRef = useRef<EntityPickerPopover>(null);
  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );

  return (
    <div ref={reactRefSetter(wrapperRef, ref)}>
      <EntityPickerPopover
        fullscreen={isMobile}
        ref={popoverRef}
        anchorEl={wrapperRef}
        disabled={disabled}
        picker={
          <TravelCostInvoiceKindPicker
            {...pickerProps}
            clearable={false}
            multiple={false}
          />
        }
      >
        <LabeledInput
          value={props.value?.name}
          name={props.name}
          disabled={disabled}
          label={label ?? t('COMMON.DOCUMENT_TYPE')}
          error={error}
          required={required}
        />
      </EntityPickerPopover>
    </div>
  );
});
